module.exports = __webpack_public_path__ + "img/signature.97bc960d.png";